import {ReducerBuilder} from "co-redux-builders";
import {PagerBackendProps} from "../../../../components/Pager";
import Alert from "../../../../model/Alert";
import TaskAlertDelete from "../../../../ws/alert/TaskAlertDelete";
import TaskAlertList from "../../../../ws/alert/TaskAlertList";
import AlertListAdminCardActions from "./AlertListAdminCardActions";

interface State {
    loading: boolean,
    alerts: Alert[],
    error: string,
    pager: PagerBackendProps,
    name: string,
}

const INITIAL_STATE: State = {
    loading: false,
    alerts: [],
    error: '',
    name: '',
    pager: {
        current: 1,
        total_pages: 1
    },
};

export default ReducerBuilder.newBuilder(INITIAL_STATE)
    .onEvent(AlertListAdminCardActions.setName, (oldState, payload) => {
        return ({
            ...oldState,
            name: payload.name,
        });
    })

    .onEvent(TaskAlertDelete.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: true}
    })
    .onEvent(TaskAlertDelete.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: false}
    })

    .onEvent(TaskAlertList.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: true}
    })
    .onEvent(TaskAlertList.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: false}
    })
    .onEvent(TaskAlertList.REDUX_ACTION_OBJECT_ON_FAIL, (oldState, payload) => {
        return {...oldState, error: payload}
    })
    .onEvent(TaskAlertList.REDUX_ACTION_OBJECT_ON_SUCCESS, (oldState, payload) => {
        return {
            ...oldState,
            alerts: payload.data,
            pager: payload.pager || oldState.pager,
        }
    })

    .onEvent(AlertListAdminCardActions.clearReducer, ((oldState, payload) => INITIAL_STATE))

    .build()
